import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import {OrderSummaryContainer} from '../../../../features/OrderSummary/OrderSummaryContainer'
import {Input} from '../../../../accountManagement/shared/Input'
import {setInfluencerName} from '../../../../app-store/kpGlobalStateSlice'
import {Spinner} from '../../../loader-spinner'
import {KPManyLinkGenerate} from './KPManyLinkGenerate'
import {SummaryActions} from './kp-many-styles'

// 1:Many Order Summary: the shared OrderSummaryContainer (Due Today / Due
// Monthly tabs, items, totals, coupons via the shared CouponSearch) — exactly
// what the 1:1 Purchase Link and Proposal Tool render. As "Continue" is in
// 1:1, the 1:Many-only controls (influencer name / share-link id and Generate
// Link) are passed in as `actions`, so they sit inside the summary's own
// gradient/border frame, like the catalog's footer.
export function KPManyLinkSummary({
  ready,
  activeItem,
  selectedCountry,
  selectedProducts,
  handleRemoveProduct,
  isNewTLMCAccessible,
  isNewCustomer,
  refreshPaymentPreview,
  updateActiveItem,
  isInfluencerOps,
  bundleId,
  isGenerateDisabled,
  buildPayload,
}) {
  const dispatch = useDispatch()
  const [influencerNote, setInfluencerNote] = useState('')

  if (!ready) return <Spinner />

  return (
    <OrderSummaryContainer
      activeItem={activeItem}
      currentId="many-link"
      idFallback="many-link"
      selectedCountry={selectedCountry}
      selectedProducts={selectedProducts}
      handleRemoveProduct={handleRemoveProduct}
      isNewTLMCAccessible={isNewTLMCAccessible}
      isNewCustomer={isNewCustomer}
      refreshPaymentPreview={refreshPaymentPreview}
      onUpdateItem={updateActiveItem}
      flushEdges
      actions={
        <SummaryActions>
          {isInfluencerOps && (
            <Input
              label="Influencer"
              required
              placeholder="Influencer Name"
              value={influencerNote}
              onChange={e => {
                setInfluencerNote(e.target.value)
                dispatch(setInfluencerName(e.target.value))
              }}
            />
          )}
          {bundleId && (
            <Input label="Share Link Id" value={bundleId} readOnly disabled />
          )}
          <KPManyLinkGenerate
            disabled={isGenerateDisabled}
            buildPayload={buildPayload}
          />
        </SummaryActions>
      }
    />
  )
}
